import { AbilityBuilder, createMongoAbility } from "@casl/ability";

export function createAbility() {
  const { can, build } = new AbilityBuilder(createMongoAbility);
  const role = JSON.parse(localStorage.getItem("yobas_role") || "null");

  if (role === "super_admin") {
    can("manage", "all");
    return build();
  }

  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");

  permissions.forEach((p) => {
    can(p.key || p, "all");
  });

  return build();
}
